namespace $ {

	export const $bog_tooltip_hush_mark = 'data-mol-tip-off'

	export const $bog_tooltip_hush_tip = 'data-mol-tip'

	export function $bog_tooltip_hush( node: Element | null ) {

		const host = node?.closest( `[${ $bog_tooltip_hush_tip }]` ) ?? null
		if( !host ) return ''

		host.setAttribute( $bog_tooltip_hush_mark, '' )

		return host.getAttribute( $bog_tooltip_hush_tip ) ?? ''
	}

	export function $bog_tooltip_hush_off( root: ParentNode | null ) {

		const held = [ ... root?.querySelectorAll( `[${ $bog_tooltip_hush_mark }]` ) ?? [] ]

		for( const host of held ) host.removeAttribute( $bog_tooltip_hush_mark )

		return held.length
	}

}
